<div class="dialog-container">
  <div class="dialog-header">
    <h4>Referral Details
    <i *ngIf="isReadOnly"
       class="fa-duotone fa-lock"
       [matTooltip]="openedReferral?.review?.isLocked
               ? 'Locked by ' + openedReferral?.review?.lockedByUser?.fullName + ' on ' + (openedReferral?.review?.lockedDate | date:'short')
               : ''">
    </i>
    </h4>
    <button mat-icon-button (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <div class="left-section">
      <div class="left-section-header">
        <h5>Referral Type: {{openedReferral?.referralType}}</h5>
        <div class="submitted-date">
          <div class="referral-value">Received On: {{ openedReferral?.receivedDate | date }}</div>
        </div>
      </div>
      

      <!-- Common Fields -->
      <div class="member-details">
        <div class="member-details-header">
          <span>Member Info</span>
          <button *ngIf="allowMemberUpdates && !isReadOnly" mat-button class="icon-hover-button" (click)="onMemberUpdate()">
            <i class="fa-sharp fa-light fa-user-pen"></i>
            <span class="button-text">Update Member Info</span>
          </button>
        </div>
        <div class="member-details-grid">
          <!-- First cell: label + value -->
          <div>
            <div class="referral-label">Member Medicaid ID:</div>
            <div class="referral-value">{{ openedReferral?.memberMedicaidId }}</div>
          </div>
          <!-- Second cell: label + value -->
          <div>
            <div class="referral-label">Member Name:</div>
            <div class="referral-value">
              {{ openedReferral?.memberFirstName }} {{ openedReferral?.memberLastName }}
            </div>
          </div>
          <!-- Third cell: label + value -->
          <div>
            <div class="referral-label">Member DOB:</div>
            <div class="referral-value">{{ openedReferral?.memberDob | date }}</div>
          </div>
          <!-- Fourth cell: label + value -->
          <div>
            <div class="referral-label">Member Phone:</div>
            <div class="referral-value">{{ openedReferral?.memberPhoneNumber | phoneNumber }}</div>
          </div>
        </div>
        <div *ngIf="hasMailingAddress()" class="mailing-label">
          <div class="referral-label">Mailing Address:</div>
          <div class="referral-value">
            <div *ngIf="openedReferral?.memberMailingAddress1">{{ openedReferral.memberMailingAddress1 }}</div>
            <div *ngIf="openedReferral?.memberMailingAddress2">{{ openedReferral.memberMailingAddress2 }}</div>
            <div>
              <span *ngIf="openedReferral?.memberMailingCity">{{ openedReferral.memberMailingCity }}</span>
              <span *ngIf="openedReferral?.memberMailingState">, {{ openedReferral.memberMailingState }}</span>
              <span *ngIf="openedReferral?.memberMailingZip">
                &nbsp;{{ formatZip(openedReferral.memberMailingZip) }}
              </span>
            </div>
          </div>
        </div>
        <div>
          <div class="referral-label">Language Spoken:</div>
          <div class="referral-value">{{ openedReferral?.memberLanguageSpoken }}</div>
        </div>
      </div>

      <div class="scrollable-section">
        <!-- HRAT Referral Fields -->
        <ng-container *ngIf="isHRATReferral(openedReferral)">
          <div class="referral-row">
            <div class="referral-label">Import Date:</div>
            <div class="referral-value">{{ openedReferral.importDate | date }}</div>
          </div>
          <div class="referral-row">
            <div class="referral-label">Referral Date:</div>
            <div class="referral-value">{{ openedReferral.referralDate | date }}</div>
          </div>

          <!-- Display question/response data for HRAT -->
          <div class="referral-row" *ngIf="openedReferral.questions?.length">
            <div class="referral-label">Questions:</div>
            <div class="referral-value">
              <div class="hrat-questions" *ngFor="let q of openedReferral.questions">
                <strong>{{ q.question }}</strong>
                <span *ngIf="q.response"> – {{ q.response }}</span>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Maternity Referral Fields -->
        <ng-container *ngIf="isMaternityReferral(openedReferral)">
          <div class="referral-row">
            <div class="referral-label">Referral Date:</div>
            <div class="referral-value">{{ openedReferral.referralDate | date }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.importDate">
            <div class="referral-label">Import Date:</div>
            <div class="referral-value">{{ openedReferral.importDate | date }}</div>
          </div>
          <div class="referral-row">
            <div class="referral-label">Provider HTRIO ID:</div>
            <div class="referral-value">{{ openedReferral.providerHtrioId }}</div>
          </div>
          <!--<div class="referral-row" *ngIf="openedReferral.uniqueId">
            <div class="referral-label">Unique ID:</div>
            <div class="referral-value">{{ openedReferral.uniqueId }}</div>
          </div>-->
          <div class="referral-row" *ngIf="openedReferral.cco">
            <div class="referral-label">CCO:</div>
            <div class="referral-value">{{ openedReferral.cco }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.importedDco">
            <div class="referral-label">Imported DCO:</div>
            <div class="referral-value">{{ openedReferral.importedDco }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.referralReason">
            <div class="referral-label">Referral Reason:</div>
            <div class="referral-value">{{ openedReferral.referralReason }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.additionalNotes">
            <div class="referral-label">Additional Notes:</div>
            <div class="referral-value">{{ openedReferral.additionalNotes }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.clinic">
            <div class="referral-label">Clinic:</div>
            <div class="referral-value">{{ openedReferral.clinic }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.questions">
            <div class="referral-label">Questions:</div>
            <div class="referral-value">{{ openedReferral.questions }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.providerNpi">
            <div class="referral-label">Provider NPI:</div>
            <div class="referral-value">{{ openedReferral.providerNpi }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.patientAwareOfRequest">
            <div class="referral-label">Patient Aware Of Request:</div>
            <div class="referral-value">{{ openedReferral.patientAwareOfRequest }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.swellingOrAbsess">
            <div class="referral-label">Swelling or Abscess:</div>
            <div class="referral-value">{{ openedReferral.swellingOrAbsess }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.cardiovascularDisease">
            <div class="referral-label">Cardiovascular Disease:</div>
            <div class="referral-value">{{ openedReferral.cardiovascularDisease }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.comments">
            <div class="referral-label">Comments:</div>
            <div class="referral-value">{{ openedReferral.comments }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.dentalCarriesOrDecay">
            <div class="referral-label">Dental Caries or Decay:</div>
            <div class="referral-value">{{ openedReferral.dentalCarriesOrDecay }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.diabetes">
            <div class="referral-label">Diabetes:</div>
            <div class="referral-value">{{ openedReferral.diabetes }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.edd">
            <div class="referral-label">EDD:</div>
            <div class="referral-value">{{ openedReferral.edd | date }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.hasOtherCondition">
            <div class="referral-label">Other Conditions:</div>
            <div class="referral-value">{{ openedReferral.otherConditions }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.hasOtherPresentation">
            <div class="referral-label">Other Presentation:</div>
            <div class="referral-value">{{ openedReferral.otherPresentation }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.oralPathology">
            <div class="referral-label">Oral Pathology:</div>
            <div class="referral-value">{{ openedReferral.oralPathology }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.pain">
            <div class="referral-label">Pain:</div>
            <div class="referral-value">{{ openedReferral.pain }}</div>
          </div>
          <div class="referral-row" *ngIf="openedReferral.pregnancy">
            <div class="referral-label">Pregnancy:</div>
            <div class="referral-value">{{ openedReferral.pregnancy }}</div>
          </div>
        </ng-container>

        <!-- PCP Referral Fields -->
        <ng-container *ngIf="isPCPReferral(openedReferral)">
          <div class="referral-row">
            <div class="referral-label">Urgent:</div>
            <div class="referral-value">{{ openedReferral.isUrgent ? 'Yes' : 'No' }}</div>
          </div>
          <div class="referral-row">
            <div class="referral-label">Guardian Name:</div>
            <div class="referral-value">{{ openedReferral.memberParentOrGuardianName }}</div>
          </div>
          <div class="referral-row">
            <div class="referral-label">Clinic Program Name:</div>
            <div class="referral-value">{{ openedReferral.clinicProgramName }}</div>
          </div>
          <div class="referral-row">
            <div class="referral-label">Clinic NPI:</div>
            <div class="referral-value">{{ openedReferral.clinicNpi }}</div>
          </div>
          <div class="referral-row">
            <div class="referral-label">Provider Name:</div>
            <div class="referral-value">{{ openedReferral.providerName }}</div>
          </div>
          <div class="referral-row">
            <div class="referral-label">Provider Phone:</div>
            <div class="referral-value">{{ openedReferral.providerPhoneNumber | phoneNumber }}</div>
          </div>
          <div class="referral-row">
            <div class="referral-label">Provider Fax:</div>
            <div class="referral-value">{{ openedReferral.providerFaxNumber | phoneNumber }}</div>
          </div>

          <div class="referral-row">
            <div class="referral-label">Clinical Presentations:</div>
            <div class="referral-value">
              <ul>
                <li *ngIf="openedReferral.dentalCariesOrDecay">Dental Caries or Decay</li>
                <li *ngIf="openedReferral.swellingOrAbscess">Swelling or Abscess</li>
                <li *ngIf="openedReferral.oralPathology">Oral Pathology</li>
                <li *ngIf="openedReferral.pain">Pain</li>
                <li *ngIf="openedReferral.otherClinicalPresentation">
                  Other: {{ openedReferral.otherClinicalPresentationDescription }}
                </li>
              </ul>
            </div>
          </div>

          <div class="referral-row">
            <div class="referral-label">Health Conditions:</div>
            <div class="referral-value">
              <ul>
                <li *ngIf="openedReferral.pregnancy">Pregnancy</li>
                <li *ngIf="openedReferral.diabetes">Diabetes</li>
                <li *ngIf="openedReferral.cardiovascularDisease">Cardiovascular Disease</li>
                <li *ngIf="openedReferral.otherMedicalConditions">
                  Other: {{ openedReferral.otherMedicalConditionsDescription }}
                </li>
              </ul>
            </div>
          </div>
          <div class="referral-row">
            <div class="referral-label">Comments About the Condition:</div>
            <div class="referral-value">{{ openedReferral.commentsAboutCondition }}</div>
          </div>
        </ng-container>
      </div>

    </div>



    <!-- Right Section: Notes -->
    <div class="right-section">

      <mat-tab-group>
        <mat-tab label="Notes">
          <app-notes-container #ReferralNotesContainer
                               (OnNewNoteSave)="SaveNewNote($event)"
                               (OnNoteSave)="SaveNote($event)"
                               (OnNoteDelete)="DeleteNote($event)"
                               [reviewId]="openedReferral?.review?.id">
          </app-notes-container>
        </mat-tab>
        <mat-tab *ngIf="showReferralActivitySection" label="Referral Activity">
          <div class="activity-container">
            <div class="review-container" *ngIf="openedReferral?.review as review">
              <h5>Review Information</h5>
              <mat-divider></mat-divider>

              <p><strong>Spoke With Member:</strong> {{ review.spokeWithMember ? 'Yes' : 'No' }}</p>
              <p><strong>Left Message:</strong> {{ review.leftMessage ? 'Yes' : 'No' }}</p>
              <p><strong>Sent Letter:</strong> {{ review.sentLetter ? 'Yes' : 'No' }}</p>
              <p><strong>Scheduled Appointment:</strong> {{ review.scheduledAppointment ? 'Yes' : 'No' }}</p>
              <p><strong>Appointment Date:</strong> {{ review.appointmentDate | date:'shortDate' }}</p>
              <p><strong>DCO Note:</strong> {{ review.dcoNote || '—' }}</p>
              <p><strong>Referral Type:</strong> {{ review.referralType }}</p>
              <p><strong>Closed:</strong> {{ review.isClosed ? 'Yes' : 'No' }}</p>
            </div>
            <div class="reprocess-container">
              <h5>Reprocess Request</h5>
              <mat-divider></mat-divider>
              <p><strong>Reprocess Reason:</strong> {{ openedReferral.reprocessReason }}</p>
              <p><strong>Additional Details:</strong> {{ openedReferral.reprocessAdditionalDetails }}</p>
            </div>
          </div>

          <div class="activity-container" *ngIf="!openedReferral?.review">
            <p>No review information available.</p>
          </div>
        </mat-tab>
        <mat-tab *ngIf="showMemberReferralHistory">
          <ng-template mat-tab-label>
            Member Referrals <span class="tab-count" *ngIf="memberReferralCount">({{ memberReferralCount }})</span>
          </ng-template>

          <div class="referral-history">
            <app-member-referral-history #MemberReferralHistoryContainer
                                         [memberId]="openedReferral?.memberMedicaidId"
                                         (refreshRequested)="onChildRequestUpstreamRefresh()"
                                         (totalChange)="memberReferralCount = $event"> 
            </app-member-referral-history>
          </div>
        </mat-tab>
        <mat-tab *ngIf="showMemberEnrollmentHistory" label="Member Enrollment">
          <div class="notes-container">
            <app-member-enrollment-details #MemberEnrollmentContainer
                                           [memberId]="openedReferral?.memberMedicaidId">
            </app-member-enrollment-details>
          </div>

        </mat-tab>
        <mat-tab label="Referral History">
          <div class="referral-history">
            <app-referral-history #ReferralHistoryContainer
                                  [referral]="openedReferral">

            </app-referral-history>
          </div>

        </mat-tab>
      </mat-tab-group>

    </div>
  </div>
  <div class="dialog-footer">
    <button *ngIf="!showMemberEnrollmentHistory" mat-flat-button color="primary" (click)="openReprocessReferralDialog(openedReferral)">
      <i class="fa-sharp-duotone fa-solid fa-share-from-square"></i>
      Reprocess Request
    </button>
  </div>
</div>
